export default __webpack_public_path__ + "static/media/project-2.67831a85.jpg";